import SimpleLightbox from 'simplelightbox';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const featuredImagesAnchors = document.querySelectorAll(
    '.single-products-top__amchor'
);
const swiperSlider = document.querySelector(
    '.single-products-top__gallery.-swiper'
);

if (featuredImagesAnchors && featuredImagesAnchors.length > 0) {
    const lightboxGallery = new SimpleLightbox(
        `.single-products-top__amchor`,
        {}
    );
}

if (swiperSlider) {
    const swiper = new Swiper(swiperSlider, {
        slidesPerView: 1,
        modules: [Navigation],
        navigation: {
            nextEl: '.-next',
            prevEl: '.-prev',
        },
    });
}
